import { render, staticRenderFns } from "./Sportradar.vue?vue&type=template&id=45765ee8"
import script from "./Sportradar.vue?vue&type=script&lang=js"
export * from "./Sportradar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports